export default __webpack_public_path__ + "static/media/plazmMethod.c5ab72cc.png";